import { ArithmeticalOperatorSymbol } from 'stores/models';

export const TEXT_MAPPER: Record<ArithmeticalOperatorSymbol, string> = {
  [ArithmeticalOperatorSymbol.sum]: 'Сумма',
  [ArithmeticalOperatorSymbol.subtract]: 'Вычитание',
  [ArithmeticalOperatorSymbol.divide]: 'Деление',
  [ArithmeticalOperatorSymbol.multiply]: 'Умножение',
};
